import React from 'react';
import type { PropsWithChildren } from 'react';
import { AppAuthContext, type AppAuthShape } from './context';

function createShim(): AppAuthShape {
  return {
    isAuthenticated: false,
    isLoading: false,
    user: undefined,
    getAccessTokenSilently: async (_options?) => '',
    loginWithRedirect: async () => {},
    logout: async () => {},
  };
}

export function Auth0ProviderBypass({
  children,
}: Readonly<PropsWithChildren>): React.ReactElement {
  const value = createShim();
  return (
    <AppAuthContext.Provider value={value}>{children}</AppAuthContext.Provider>
  );
}
